import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

export interface BreadcrumbItem {
    label: string;
    url: string;
    icon?: string;
    level: number;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationTreeService {
    private breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
    private showBreadcrumbSubject = new BehaviorSubject<boolean>(true);
    
    public breadcrumbs$: Observable<BreadcrumbItem[]> = this.breadcrumbsSubject.asObservable();
    public showBreadcrumb$: Observable<boolean> = this.showBreadcrumbSubject.asObservable();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateBreadcrumbs();
        });
    }

    private updateBreadcrumbs(): void {
        let route = this.activatedRoute.root;
        let breadcrumbs: BreadcrumbItem[] = [];
        let shouldShowBreadcrumb = true;

        // Parcourir l'arbre des routes
        while (route) {
            // Vérifier si la route courante ou ses enfants ont hideBreadcrumb
            if (route.snapshot.data['hideBreadcrumb']) {
                shouldShowBreadcrumb = false;
                break;
            }

            // Vérifier les enfants
            if (route.firstChild) {
                route = route.firstChild;
                if (route.snapshot.data['hideBreadcrumb']) {
                    shouldShowBreadcrumb = false;
                    break;
                }
                
                // Construire le breadcrumb si disponible
                if (route.snapshot.data['breadcrumb']) {
                    const breadcrumb: BreadcrumbItem = {
                        label: route.snapshot.data['breadcrumb'],
                        url: this.createUrl(route.snapshot),
                        icon: route.snapshot.data['icon'],
                        level: breadcrumbs.length
                    };
                    breadcrumbs.push(breadcrumb);
                }
            } else {
                break;
            }
        }

        this.showBreadcrumbSubject.next(shouldShowBreadcrumb);
        this.breadcrumbsSubject.next(breadcrumbs);
    }

    private createUrl(snapshot: any): string {
        // Logique pour créer l'URL complète
        return snapshot.pathFromRoot.map((s: any) => s.url.map((u: any) => u.path).join('/')).join('/');
    }

    getCurrentPath(): string {
        return this.router.url;
    }
}
